define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/MessageCenterActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    // hasLoaded is set when we load settings. We need it so we don't do
    // certain things without having the correct settings. For instance, if the
    // user is pro but the settings load after the popup, the popup will fail
    // validating and the default popup will be shown.
    hasLoaded: false,
    notice: Immutable.Map(),
    lastContactedAt: false,
    name: '',
    page: 1,
    state: [
      'queued',
      'sending',
      'sent',
    ],
    status: Immutable.List(['draft', 'scheduled', 'queued', 'sent', 'active', 'paused', 'sending']),
    campaignType: Immutable.List(['email', 'sumomail-welcome', 'push']),
  });

  const actionHandlers = {};

  const cleanSettings = (state, settings) => (
    Object.keys(settings).reduce((memo, key) => {
      if (!settings[key]) return memo;
      return Object.assign({}, memo, { [key]: settings[key] });
    }, {})
  );

  actionHandlers[Actions.RECEIVE_SETTINGS] = (state, action) => {
    const settings = action.settings || {};
    const nextSettings = Object.assign({}, cleanSettings(state, settings), { hasLoaded: true });
    return state.merge(nextSettings);
  };

  actionHandlers[Actions.UPDATE_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (!settingName || !settingValue) return state;
    return state.setIn([settingName], Immutable.fromJS(settingValue));
  };

  actionHandlers[Actions.UPDATE_SETTINGS] = (state, action) => {
    const settings = action.settings || {};
    const nextSettings = cleanSettings(state, settings);

    return state.merge(nextSettings);
  };

  return Util.createReducer(initialState, actionHandlers);
});
